module.exports = __webpack_public_path__ + "static/media/ic_disconnected.d723358e.svg";